export default [
    'brent-goose',
    'canada-goose',
    'barnacle-goose',
    'cackling-goose',
    'snow-goose',
    'greylag-goose',
    'taiga-bean-goose',
    'pink-footed-goose',
    'tundra-bean-goose',
    'white-fronted-goose',
    'lesser-white-fronted-goose',
    'mute-swan',
    'whooper-swan',
    'shelduck',
    'ruddy-shelduck',
    'mandarin-duck',
    'baikal-teal',
    'garganey',
    'blue-winged-teal',
    'shoveler',
    'gadwall',
    'falcated-duck',
    'wigeon',
    'mallard',
    'black-duck',
    'pintail',
    'teal',
    'green-winged-teal',
    'red-crested-pochard',
    'canvasback',
    'redhead',
    'pochard',
    'ferruginous-duck',
    'ring-necked-duck',
    'tufted-duck',
    'scaup',
    'lesser-scaup',
    'king-eider',
    'eider',
    'harlequin-duck',
    'surf-scoter',
    'velvet-scoter',
    'white-winged-scoter',
    'common-scoter',
    'black-scoter',
    'long-tailed-duck',
    'bufflehead',
    'goldeneye',
    'smew',
    'hooded-merganser',
    'goosander',
    'ruddy-duck',
    'red-grouse',
    'ptarmigan',
    'capercaillie',
    'black-grouse',
    'grey-partridge',
    'golden-pheasant',
    'pheasant',
    'quail',
    'red-legged-partridge',
    'common-nighthawk',
    'nightjar',
    'white-throated-needletail',
    'chimney-swift',
    'alpine-swift',
    'swift',
    'pallid-swift',
    'pacific-swift',
    'little-swift',
    'white-rumped-swift',
    'great-spotted-cuckoo',
    'yellow-billed-cuckoo',
    'black-billed-cuckoo',
    'cuckoo',
    'rock-dove',
    'stock-dove',
    'woodpigeon',
    'turtle-dove',
    'collared-dove',
    'mourning-dove',
    'water-rail',
    'corncrake',
    'sora-rail',
    'spotted-crake',
    'moorhen',
    'coot',
    'western-swamphen',
    'little-crake',
    'sandhill-crane',
    'crane',
    'little-grebe',
    'pied-billed-grebe',
    'great-crested-grebe',
    'black-necked-grebe',
    'stone-curlew',
    'oystercatcher',
    'black-winged-stilt',
    'avocet',
    'lapwing',
    'sociable-plover',
    'white-tailed-plover',
    'golden-plover',
    'pacific-golden-plover',
    'grey-plover',
    'ringed-plover',
    'little-ringed-plover',
    'killdeer',
    'kentish-plover',
    'lesser-sand-plover',
    'greater-sand-plover',
    'caspian-plover',
    'dotterel',
    'upland-sandpiper',
    'whimbrel',
    'little-whimbrel',
    'curlew',
    'turnstone',
    'great-knot',
    'broad-billed-sandpiper',
    'sharp-tailed-sandpiper',
    'stilt-sandpiper',
    'curlew-sandpiper',
    'long-toed-stint',
    'sanderling',
    'dunlin',
    'purple-sandpiper',
    'little-stint',
    'least-sandpiper',
    'white-rumped-sandpiper',
    'pectoral-sandpiper',
    'western-sandpiper',
    'long-billed-dowitcher',
    'short-billed-dowitcher',
    'jack-snipe',
    'great-snipe',
    'snipe',
    'terek-sandpiper',
    'grey-phalarope',
    'common-sandpiper',
    'spotted-sandpiper',
    'green-sandpiper',
    'solitary-sandpiper',
    'grey-tailed-tattler',
    'lesser-yellowlegs',
    'redshank',
    'marsh-sandpiper',
    'wood-sandpiper',
    'spotted-redshank',
    'greenshank',
    'greater-yellowlegs',
    'cream-coloured-courser',
    'collared-pratincole',
    'black-winged-pratincole',
    'kittiwake',
    'ivory-gull',
    'slender-billed-gull',
    'black-headed-gull',
    'little-gull',
    'laughing-gull',
    'mediterranean-gull',
    'great-black-headed-gull',
    'common-gull',
    'ring-billed-gull',
    'great-black-backed-gull',
    'glaucous-winged-gull',
    'glaucous-gull',
    'iceland-gull',
    'herring-gull',
    'caspian-gull',
    'yellow-legged-gull',
    'slaty-backed-gull',
    'lesser-black-backed-gull',
    'gull-billed-tern',
    'caspian-tern',
    'royal-tern',
    'lesser-crested-tern',
    'sandwich-tern',
    'elegant-tern',
    'little-tern',
    'least-tern',
    'aleutian-tern',
    'bridled-tern',
    'sooty-tern',
    'roseate-tern',
    'common-tern',
    'arctic-tern',
    'whiskered-tern',
    'white-winged-black-tern',
    'black-tern',
    'south-polar-skua',
    'great-skua',
    'pomarine-skua',
    'arctic-skua',
    'long-tailed-skua',
    'little-auk',
    'common-guillemot',
    'razorbill',
    'great-auk',
    'black-guillemot',
    'long-billed-murrelet',
    'ancient-murrelet',
    'puffin',
    'tufted-puffin',
    'red-billed-tropicbird',
    'red-throated-diver',
    'pacific-diver',
    'great-northern-diver',
    'albatross',
    'storm-petrel',
    'fulmar',
    'great-shearwater',
    'stork',
    'ascension-frigatebird',
    'magnificent-frigatebird',
    'gannet',
    'cormorant',
    'double-crested-cormorant',
    'glossy-ibis',
    'spoonbill',
    'bittern',
    'little-bittern',
    'night-heron',
    'green-heron',
    'cattle-egret',
    'grey-heron',
    'great-blue-heron',
    'purple-heron',
    'great-white-egret',
    'snowy-egret',
    'little-egret',
    'osprey',
    'vulture',
    'honey-buzzard',
    'short-toed-eagle',
    'spotted-eagle',
    'golden-eagle',
    'sparrowhawk',
    'goshawk',
    'marsh-harrier',
    'hen-harrier',
    'northern-harrier',
    'pallid-harrier',
    'red-kite',
    'black-kite',
    'white-tailed-eagle',
    'rough-legged-buzzard',
    'buzzard',
    'barn-owl',
    'little-owl',
    'hawk-owl',
    'scops-owl',
    'long-eared-owl',
    'short-eared-owl',
    'snowy-owl',
    'tawny-owl',
    'hoopoe',
    'roller',
    'kingfisher',
    'belted-kingfisher',
    'blue-cheeked-bee-eater',
    'bee-eater',
    'wryneck',
    'lesser-spotted-woodpecker',
    'great-spotted-woodpecker',
    'green-woodpecker',
    'lesser-kestrel',
    'kestrel',
    'red-footed-falcon',
    'amur-falcon',
    'merlin',
    'hobby',
    'gyr-falcon',
    'peregrine',
    'ring-necked-parakeet',
    'eastern-phoebe',
    'yellow-bellied-flycatcher',
    'acadian-flycatcher',
    'alder-flycatcher',
    'eastern-kingbird',
    'brown-shrike',
    'red-backed-shrike',
    'long-tailed-shrike',
    'lesser-grey-shrike',
    'great-grey-shrike',
    'woodchat-shrike',
    'masked-shrike',
    'yellow-throated-vireo',
    'golden-oriole',
    'jay',
    'magpie',
    'jackdaw',
    'rook',
    'carrion-crow',
    'hooded-crow',
    'raven',
    'waxwing',
    'cedar-waxwing',
    'woodlark',
    'white-winged-lark',
    'skylark',
    'crested-lark',
    'shore-lark',
    'short-toed-lark',
    'bimaculated-lark',
    'calandra-lark',
    'black-lark',
    'sand-martin',
    'tree-swallow',
    'purple-martin',
    'crag-martin',
    'swallow',
    'house-martin',
    'red-rumped-swallow',
    'wood-warbler',
    'yellow-browed-warbler',
    'dusky-warbler',
    'willow-warbler',
    'chiffchaff',
    'iberian-chiffchaff',
    'eastern-crowned-warbler',
    'green-warbler',
    'greenish-warbler',
    'arctic-warbler',
    'great-reed-warbler',
    'aquatic-warbler',
    'sedge-warbler',
    'reed-warbler',
    'marsh-warbler',
    'thick-billed-warbler',
    'booted-warbler',
    'olive-tree-warbler',
    'melodious-warbler',
    'icterine-warbler',
    'lanceolated-warbler',
    'river-warbler',
    'grasshopper-warbler',
    'fan-tailed-warbler',
    'blackcap',
    'garden-warbler',
    'barred-warbler',
    'lesser-whitethroat',
    'whitethroat',
    'spectacled-warbler',
    'dartford-warbler',
    'ruby-crowned-kinglet',
    'firecrest',
    'goldcrest',
    'wren',
    'nuthatch',
    'wallcreeper',
    'treecreeper',
    'short-toed-treecreeper',
    'grey-catbird',
    'northern-mockingbird',
    'brown-thrasher',
    'rose-coloured-starling',
    'starling',
    'varied-thrush',
    'wood-thrush',
    'hermit-thrush',
    'grey-cheeked-thrush',
    'veery',
    'siberian-thrush',
    'song-thrush',
    'mistle-thrush',
    'redwing',
    'blackbird',
    'eyebrowed-thrush',
    'fieldfare',
    'ring-ouzel',
    'black-throated-thrush',
    'red-throated-thrush',
    'dusky-thrush',
    'spotted-flycatcher',
    'asian-brown-flycatcher',
    'robin',
    'siberian-blue-robin',
    'bluethroat',
    'thrush-nightingale',
    'nightingale',
    'red-flanked-bluetail',
    'pied-flycatcher',
    'collared-flycatcher',
    'redstart',
    'rock-thrush',
    'blue-rock-thrush',
    'whinchat',
    'stonechat',
    'wheatear',
    'desert-wheatear',
    'pied-wheatear',
    'dipper',
    'rock-sparrow',
    'tree-sparrow',
    'spanish-sparrow',
    'house-sparrow',
    'alpine-accentor',
    'dunnock',
    'yellow-wagtail',
    'citrine-wagtail',
    'grey-wagtail',
    'pied-wagtail',
    'tawny-pipit',
    'meadow-pipit',
    'tree-pipit',
    'olive-backed-pipit',
    'pechora-pipit',
    'red-throated-pipit',
    'buff-bellied-pipit',
    'water-pipit',
    'rock-pipit',
    'chaffinch',
    'brambling',
    'evening-grosbeak',
    'pine-grosbeak',
    'bullfinch',
    'trumpeter-finch',
    'common-rosefinch',
    'greenfinch',
    'linnet',
    'common-redpoll',
    'lesser-redpoll',
    'arctic-redpoll',
    'parrot-crossbill',
    'crossbill',
    'two-barred-crossbill',
    'goldfinch',
    'citril-finch',
    'serin',
    'siskin',
    'snow-bunting',
    'corn-bunting',
    'yellowhammer',
    'pine-bunting',
    'rock-bunting',
    'ortolan-bunting',
    'cirl-bunting',
    'chestnut-eared-bunting',
    'little-bunting',
    'yellow-browed-bunting',
    'rustic-bunting',
    'chestnut-bunting',
    'reed-bunting',
    'lark-sparrow',
    'song-sparrow',
    'eastern-towhee',
    'bobolink',
    'red-winged-blackbird',
    'ovenbird',
    'northern-waterthrush',
    'golden-winged-warbler',
    'common-yellowthroat',
    'hooded-warbler',
    'northern-parula',
    'magnolia-warbler',
    'blackburnian-warbler',
    'yellow-warbler',
    'chestnut-sided-warbler',
    'blackpoll-warbler',
    'yellow-rumped-warbler',
    'summer-tanager',
    'scarlet-tanager',
    'indigo-bunting'
]
